import React, { useEffect, useState, useRef } from 'react';

const Countable = () => {
    const statsData = [
        {
          id: 0,
          imgSrc: "https://everymatrix.com/wp-content/uploads/2019/04/ce-content-stats-1.svg",
          alt: "Casino Games",
          end: 34780,
          title: "Casino Games",
        },
        {
          id: 1,
          imgSrc: "https://everymatrix.com/wp-content/uploads/2019/04/ce-content-stats-2.svg",
          alt: "Vendor Integrations",
          end: 180,
          title: "Vendor Integrations",
        },
        {
          id: 2,
          imgSrc: "https://everymatrix.com/wp-content/uploads/2019/04/ce-content-stats-3.svg",
          alt: "Content Providers",
          end: 349,
          title: "Content Providers",
        },
        {
          id: 3,
          imgSrc: "https://everymatrix.com/wp-content/uploads/2019/04/ce-content-stats-4.svg",
          alt: "Local & Global Jackpots",
          end: 401,
          title: "Local & Global Jackpots",
        },
      ];
        const [counters, setCounters] = useState(statsData.map(() => 0));
        const sectionRef = useRef(null);
        const hasAnimated = useRef(false);

        useEffect(() => {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && !hasAnimated.current) {
                  animateCounters();
                  hasAnimated.current = true;
                }
              });
            },
            { threshold: 0.4 } // 40% visible
          );

          if (sectionRef.current) {
            observer.observe(sectionRef.current);
          }

          return () => {
            if (sectionRef.current) {
              observer.unobserve(sectionRef.current);
            }
          };
        }, []);

        const animateCounters = () => {
          statsData.forEach((stat, index) => {
            let start = 0;
            const end = stat.end;
            const duration = 2000; // 2 seconds
            const increment = Math.ceil(end / (duration / 20)); // 20ms update

            const counterInterval = setInterval(() => {
              start += increment;
              if (start >= end) {
                start = end;
                clearInterval(counterInterval);
              }
              setCounters((prev) => {
                const updated = [...prev];
                updated[index] = start;
                return updated;
              });
            }, 20);
          });
        };

  return (
    <>
      <section className="stats" id="explore" ref={sectionRef}>
      <div className="container container_custom">
        <div className="row">
          <div className="col-md-12">
            <ul className="d-flex flex-wrap justify-content-center p-0 m-0">
              {statsData.map((stat, index) => (
                <li
                  key={stat.id}
                  className={`stats-${stat.id}`}
                  style={{
                    listStyle: "none",
                    margin: "20px",
                    textAlign: "center",
                  }}
                >
                  <div className="li-inner">
                    <div className="img-holder">
                      <img
                        src={stat.imgSrc}
                        alt={stat.alt}

                      />
                    </div>
                    <b>
                      {counters[index]}+
                    </b>
                    <h4 style={{ marginTop: "5px" }}>{stat.title}</h4>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default Countable